export const articles = [
  {
    id: 'article-1',
    slug: 'best-productivity-tools-2025',
    title: '2025年最值得收藏的效率工具推荐',
    excerpt: '在这个信息爆炸的时代，选择对的工具能让你的工作效率翻倍。我们为你精选了10款备受好评的效率神器，从任务管理到时间追踪，全方位提升你的工作效率。',
    content: `<p>在快节奏的现代生活中，高效利用时间已经成为每个人追求的目标。本文将为大家推荐十款经过精挑细选的效率工具，帮助你在2025年更好地管理时间和任务。</p><h3>1. Notion - 全能型知识管理工具</h3><p>Notion已经从一个简单的笔记应用发展成为集文档、数据库、项目管理于一体的全能型工作空间。它的强大之处在于灵活的模块化设计，你可以像搭积木一样构建自己的工作系统。</p><p>无论是个人知识库、团队Wiki、项目管理还是日程安排，Notion都能胜任。特别是它的数据库功能，支持表格、看板、日历、画廊等多种视图，让数据可视化变得异常简单。</p><h3>2. Todoist - 极简任务管理</h3><p>Todoist以其简洁优雅的设计和强大的自然语言识别能力著称。你只需输入"明天下午3点开会"，它就会自动识别并设置提醒时间。</p><p>它的Karma积分系统让完成任务变得有成就感，支持跨平台同步，无论是手机还是电脑都能随时查看待办事项。</p><h3>3. Obsidian - 第二大脑</h3><p>Obsidian是一款基于本地Markdown文件的知识管理工具，最大的特色是双向链接和关系图谱。通过建立笔记之间的链接，你可以构建起自己的知识网络。</p><p>丰富的插件生态系统让Obsidian的功能可以无限扩展，从日记模板到任务管理，从数据可视化到幻灯片演示，应有尽有。</p>`,
    category: 'common-tools',
    categoryName: '常用工具',
    author: '草莓导航编辑',
    date: '2025-12-15',
    readTime: '8分钟',
    tags: ['效率工具', '时间管理', '知识管理', '推荐'],
    imageSeq: 'article-prod-tools',
  },
  {
    id: 'article-2',
    slug: 'online-learning-platform-guide',
    title: '在线学习平台大盘点：找到最适合你的那个',
    excerpt: '从MOOC到付费课程，从国内到国外，在线学习的选择越来越多。本文帮你全面对比主流学习平台，让你的学习之路不再迷茫。',
    content: `<p>随着互联网技术的发展，在线学习已经成为获取知识的重要途径。面对琳琅满目的学习平台，如何选择最适合自己的呢？本文将从多个维度为你深度分析。</p><h3>国内平台篇</h3><p><strong>中国大学MOOC</strong>：与国内顶尖高校合作，提供大量免费精品课程。适合系统的学术学习和考证备考。课程质量有保障，但互动性相对较弱。</p><p><strong>网易云课堂</strong>：偏向职业技能培训，涵盖IT互联网、职场软技能、设计创意等领域。付费课程为主，但经常有优惠活动。</p><p><strong>B站知识区</strong>：近年崛起的免费学习宝库，UP主们贡献了大量优质教程。内容更新快、形式活泼，尤其适合编程和技术学习。</p><h3>国际平台篇</h3><p><strong>Coursera</strong>：与全球200+顶尖大学合作，提供从单门课程到完整学位的全方位学习体验。部分课程可获得认证证书。</p><p><strong>Udemy</strong>：全球最大的在线课程市场，课程数量超过20万门。经常有大幅折扣，性价比极高。</p>`,
    category: 'learning',
    categoryName: '学习资源',
    author: '草莓导航编辑',
    date: '2025-11-28',
    readTime: '10分钟',
    tags: ['在线学习', 'MOOC', '教育', '平台对比'],
    imageSeq: 'article-learning',
  },
  {
    id: 'article-3',
    slug: 'must-have-browser-extensions',
    title: '提升浏览体验：这15款浏览器插件值得安装',
    excerpt: '浏览器插件可以让你的网页浏览体验发生质的飞跃。从广告拦截到密码管理，从截图标注到网页翻译，这些插件将成为你的得力助手。',
    content: `<p>浏览器是我们每天使用最多的软件之一，而合适的插件可以让它变得更加强大。本文为你整理了15款经过实测验证的优秀浏览器插件。</p><h3>生产力类</h3><p><strong>uBlock Origin</strong>：轻量级广告拦截器，相比其他同类产品占用更少内存。不仅拦截广告，还能屏蔽恶意网站和追踪脚本。</p><p><strong>OneTab</strong>：当你打开太多标签页导致浏览器卡顿时，一键将所有标签转为列表，节省95%的内存。需要时还能一键恢复。</p><p><strong>LastPass</strong>：密码管理器，帮你记住所有网站密码，只需记住一个主密码即可。支持自动填充和密码生成。</p><h3>阅读与学习类</h3><p><strong>沉浸式翻译</strong>：国内开发者制作的翻译插件，支持双语对照显示，阅读英文网页的利器。支持多种翻译引擎。</p><p><strong>简悦</strong>：让你进入沉浸式阅读模式，去除网页上多余的干扰元素，提供舒适的阅读体验和多种主题。</p>`,
    category: 'common-tools',
    categoryName: '常用工具',
    author: '草莓导航编辑',
    date: '2025-11-10',
    readTime: '7分钟',
    tags: ['浏览器', '插件', '效率', '工具'],
    imageSeq: 'article-extensions',
  },
  {
    id: 'article-4',
    slug: 'ai-tools-revolution-2025',
    title: 'AI工具正在改变我们的工作方式：2025现状与展望',
    excerpt: '人工智能工具正在以前所未有的速度渗透到各行各业。从文案写作到代码生成，从图像设计到数据分析，AI正在重新定义我们的工作流程。',
    content: `<p>2025年，AI工具已经从一个热门话题变成了日常工作中不可或缺的一部分。本文将探讨AI工具在各领域的应用现状和未来趋势。</p><h3>AI写作工具</h3><p>以ChatGPT、Claude为代表的AI对话助手已经成为许多人的写作帮手。无论是撰写邮件、润色文案，还是头脑风暴、翻译校对，AI都能提供即时帮助。</p><p>特别是对于内容创作者来说，AI工具能够大幅缩短从构思到成文的时间，让他们可以将更多精力放在创意和策略上。</p><h3>AI编程工具</h3><p>GitHub Copilot和Cursor等AI编程助手正在改变开发者写代码的方式。它们不仅能自动补全代码，还能根据注释生成完整的功能实现。</p><p>对于入门级开发者来说，AI编程工具大大降低了学习曲线；对于资深开发者来说，它们则能大幅提升日常开发效率。</p><h3>AI设计工具</h3><p>Midjourney、Stable Diffusion等AI图像生成工具以及Canva的AI功能，让非设计师也能创作出专业水准的视觉内容。</p>`,
    category: 'dev-tech',
    categoryName: '开发技术',
    author: '草莓导航编辑',
    date: '2025-10-22',
    readTime: '12分钟',
    tags: ['AI', '人工智能', '效率', '未来趋势'],
    imageSeq: 'article-ai-tools',
  },
  {
    id: 'article-5',
    slug: 'remote-work-tools-collection',
    title: '远程办公必备工具大全：从沟通到协作一站式解决',
    excerpt: '远程办公已经成为越来越多人的工作常态。本文为你整理了远程办公全流程的工具方案，帮助团队保持高效协作。',
    content: `<p>后疫情时代，远程办公已成为许多公司和个人的选择。但远程办公也带来了沟通效率下降、协作不顺畅等挑战。合适的工具是解决这些问题的关键。</p><h3>即时通讯</h3><p><strong>飞书</strong>：字节跳动出品的企业协作平台，集即时通讯、文档协作、日程管理于一体。特别是它的文档和表格功能非常强大。</p><p><strong>钉钉</strong>：阿里巴巴旗下的企业通讯工具，在国内有广泛的用户基础，特别适合中小企业和教育场景。</p><h3>视频会议</h3><p><strong>腾讯会议</strong>：国内最主流的视频会议工具，免费版支持300人同时在线，稳定性好，与微信生态深度整合。</p><p><strong>Zoom</strong>：国际视频会议领导者，功能丰富，虚拟背景、分组讨论、白板协作等一应俱全。</p>`,
    category: 'common-tools',
    categoryName: '常用工具',
    author: '草莓导航编辑',
    date: '2025-09-15',
    readTime: '9分钟',
    tags: ['远程办公', '协作', '效率', '工具'],
    imageSeq: 'article-remote',
  },
  {
    id: 'article-6',
    slug: 'shopping-website-comparison',
    title: '2025年主流购物网站深度对比：从价格到服务全面分析',
    excerpt: '网购平台越来越多，每家都有自己的优势和特点。本文从价格、物流、售后、品类等多个维度，帮你找到最适合自己的购物平台。',
    content: `<p>中国电商市场竞争激烈，各大平台各显神通。作为消费者，了解各平台的特点能帮你做出更明智的购物决策。</p><h3>综合电商平台对比</h3><p><strong>淘宝</strong>：商品种类最全，从日用品到小众手作应有尽有。价格区间大，性价比需仔细比对。适合淘新奇小物和个性化商品。</p><p><strong>京东</strong>：自营商品正品保障，物流速度快（211限时达）。家电数码品类优势明显，售后服务体系完善。价格相对偏高但服务有保障。</p><p><strong>拼多多</strong>：价格优势明显，拼团模式下价格更低。农产品和白牌商品性价比突出。适合价格敏感型消费。</p>`,
    category: 'shopping',
    categoryName: '购物消费',
    author: '草莓导航编辑',
    date: '2025-08-20',
    readTime: '11分钟',
    tags: ['购物', '电商', '对比', '消费'],
    imageSeq: 'article-shopping',
  },
];

export const featuredArticleIds = ['article-1', 'article-2', 'article-3'];